import {
  BlockOutlined,
  DeleteFilled,
  DeleteOutlined,
  ExportOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Typography,
  Card,
  Select,
  Input,
  Radio,
  Button,
  Space,
  Form,
  Popconfirm,
  notification,
  Table,
} from "antd";
import * as XLSX from "xlsx";
import moment from "moment";
import { useEffect, useState } from "react";

import { PrestationsService } from "../Services/PrestationsService";
import { SpecialitesService } from "../Services/SpecialitesService";
import { AffectationActeService } from "../Services/AffectationActeService";
const { Title } = Typography;
const { Option } = Select;

const AffectationActe = () => {
  const initialTableData = [];
  const [filteredData, setFilteredData] = useState(initialTableData);
  // const [showEditForm, setShowEditForm] = useState(false);

  const [prestations, setPrestations] = useState([]);
  const [prestationAffect, setPrestationAffect] = useState([]);
  const [specialites, setSpecialites] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [compte, setCompte] = useState("");

  const [selectedRecord, setSelectedRecord] = useState(null);

  const [selectedSpecialite, setSelectedSpecialite] = useState("00");
  
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("a");
  const [tableData, setTableData] = useState(initialTableData);

  const [form] = Form.useForm();

  const affectationService = new AffectationActeService();
  const prestationsService = new PrestationsService();
  const specialitesService = new SpecialitesService();

  useEffect(() => {
    setLoading(true);
    affectationService
      .getAllAffectationActe(selectedSpecialite)
      .then((data) => {
        setTableData(data);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [selectedSpecialite]);

  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  useEffect(() => {
    if (prestations.length === 0) {
      prestationsService
        .getAllPrestation()
        .then((data) => {
          setPrestations(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }

    if (specialites.length === 0) {
      specialitesService
        .getAllSpecialites()
        .then((data) => {
          setSpecialites(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }
  }, [prestations, specialites]);

  // const handleDelete = async (record) => {};

  //Filtre recherche
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered);
  };

  //Actualisation
  const handleResetAll = async () => {
    await affectationService.getAllAffectationActe(selectedSpecialite);
  };

  const handleRowClick = (record) => {
    form.setFieldsValue({
      codespe: record.codespe,
      codeprest: record.codeprest,
      codeacte: record.codeacte,
      libacte: record.libacte,
      compte: record.compte,
    });
    setCompte(record.compte);
    setSelectedRecord(record);
    // setShowEditForm(true);
  };

  useEffect(() => {
    let updatedData = [];
    if (selectedOption === "a") {
      updatedData = tableData; // Affiche toutes les données
    } else if (selectedOption === "b") {
      updatedData = tableData.filter((item) => item.exclus); // Affiche les données exclues
    } else if (selectedOption === "c") {
      updatedData = tableData.filter((item) => !item.exclus); // Affiche les données non exclues
    }
    setFilteredData(updatedData);
  }, [selectedOption, tableData]);

 

  const handleExport = () => {
    let dataToExport = [];

    if (selectedRowKeys.length > 0) {
      // Exporter seulement les lignes sélectionnées
      dataToExport = filteredData.filter((item, index) =>
        selectedRowKeys.includes(index + 1)
      );
    } else {
      // Aucune ligne sélectionnée, exporter toutes les lignes
      dataToExport = filteredData;
    }

    const ws = XLSX.utils.json_to_sheet(dataToExport); // Convertir les données JSON en feuille de calcul
    const wb = XLSX.utils.book_new(); // Créer un nouveau classeur
    XLSX.utils.book_append_sheet(wb, ws, "ExportedData"); // Ajouter la feuille de calcul au classeur

    // Écrire le fichier et déclencher le téléchargement
    XLSX.writeFile(wb, "exported_data.xlsx");
  };

  const handlePrestationChange = async (prestationId) => {
    try {
      setLoading(true); // Active l'indicateur de chargement

      // Appel de l'API via getPresta pour récupérer les actes et le compte associés
      const response = await prestationsService.getPresta(prestationId);
      setPrestationAffect(response);
    } catch (error) {
      console.error("Erreur lors de la récupération des actes :", error);
      notification.error({
        message: "Erreur de chargement",
        description: "Impossible de charger les informations d'acte.",
      });
    } finally {
      setLoading(false); // Désactive l'indicateur de chargement
    }
  };

  const handleFormSubmit = async (values) => {
    // Crée un objet avec toutes les valeurs nécessaires du formulaire
    const acteDetails = {
      codeacte: selectedRecord ? selectedRecord.codeacte : values.codeacte,
      codeprest: values.codeprest,
      codespe: values.codespe,
      coef: 0, // Mettre ici les valeurs par défaut ou celles calculées si nécessaire
      compte: prestationAffect.compte,
      exclus: values.exclus || null,
      lettre_cle: values.lettre_cle || null,
      libacte: values.libacte || null,

      period_plafond: values.period_plafond || null,
      plafond_part: values.plafond_part || null,
      tarif: values.tarif || 0,
    };

    try {
      let response;
      if (selectedRecord) {
      
      } else {
        response = await affectationService.addAffectationActe(acteDetails);
        notification.success({ message: "Acte ajouté avec succès!" });
        
        const updatedData = await affectationService.getAllAffectationActe(
          selectedSpecialite
        );
        setTableData(updatedData);
      }
      //  form.resetFields();
      setSelectedRecord(null);
    } catch (error) {
      console.error("Erreur lors de la soumission de l'acte:", error);
      notification.error({ message: "Acte déja ajouté" });
    }
  };
  const handleDelete = async (record) => {
    try {
      await affectationService.deleteAffctation(record);
      console.log(record);
      notification.success({
        message: "Succès",
        description: "Acte supprimé avec succès.",
      });
      const updatedData = await affectationService.getAllAffectationActe(
        selectedSpecialite
      );
      setTableData(updatedData);
    } catch (error) {
      console.error("Erreur lors de la suppression de l'acte :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression de l'acte.",
      });
    }
  };

  const handleSpecialiteChange = (value) => {
    setSelectedSpecialite(value);
    form.setFieldsValue({ codespe: value });
    const filtered = tableData.filter(
      (item) => (value ? item.codespe === value : true) // Filtrer par `codeacte` égal au `codespe` sélectionné
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "codeacte",
      key: "codeacte",
      className: "small-cell",
      align: "center",
      ellipsis: true,
      sorter: (a, b) => {
        const valueA = a.codeacte || "";
        const valueB = b.codeacte || "";
        return valueA.localeCompare(valueB);
      },
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Libellé",
      dataIndex: "libacte",
      key: "libacte",
      className: "small-cell",
      ellipsis: true,
      sorter: (a, b) => {
        const valueA = a.libacte || "";
        const valueB = b.libacte || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Lettre Clé",
      dataIndex: "lettre_cle",
      key: "lettre_cle",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.lettre_cle || "";
        const valueB = b.lettre_cle || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Coeff.",
      dataIndex: "coef",
      key: "coef",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.coef || "";
        const valueB = b.coef || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Tarif",
      dataIndex: "tarif",
      key: "tarif",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.tarif || "";
        const valueB = b.tarif || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        const valueA = a.compte || "";
        const valueB = b.compte || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (text) => (text ? moment(text).format("DD/MM/YYYY") : ""),
      sorter: (a, b) => {
        const valueA = new Date(a.datecreation).getTime();
        const valueB = new Date(b.datecreation).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Créer par",
      dataIndex: "create_by",
      key: "create_by",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (text ? moment(text).format("DD/MM/YYYY") : ""),
      sorter: (a, b) => {
        const valueA = a.create_by || "";
        const valueB = b.create_by || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",

      ellipsis: true,
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  // Fonction pour gérer la sélection des lignes
  const onSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  // Configuration pour la sélection des lignes dans la table
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
 
  useEffect(() => {
    form.setFieldsValue({ codespe: "00" });
  }, [form]);
  const handleExclude = async () => {
    let dataToExclude = [];

    if (selectedRowKeys.length > 0) {
      dataToExclude = filteredData.filter((item, index) =>
        selectedRowKeys.includes(index + 1)
      );
    } else {
      dataToExclude = filteredData;
    }

    try {
      const result = await affectationService.updateAffctation(dataToExclude);
      if (result.url) {
        window.location.href = result.url; // Si l'API retourne un lien pour télécharger le fichier
      }
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'exportation",
        description:
          "Une erreur s'est produite lors de la tentative d'exportation des données.",
      });
    }
  };
  const Handlesuppresion = async () => {
    let dataToSupp = [];

    if (selectedRowKeys.length > 0) {
      dataToSupp = filteredData.filter((item, index) =>
        selectedRowKeys.includes(index + 1)
      );
    } else {
      dataToSupp = filteredData;
    }

    try {
      const result = await affectationService.deleteAffctationlines(dataToSupp);
      notification.success({
        message: "Succès",
        description: "Acte(s) supprimé(s) avec succès.",
      });
      const updatedData = await affectationService.getAllAffectationActe(
        selectedSpecialite
      );
      setTableData(updatedData);
      setSelectedRowKeys([]);
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'exportation",
        description:
          "Une erreur s'est produite lors de la tentative d'exportation des données.",
      });
    }
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card bordered>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} lg={12}>
                <Row gutter={8} align="middle">
                  <Col xs={12}>
                    <label>Specialités / Structures</label>
                    <Select
                      bordered={false}
                      style={{ width: "100%", borderBottom: "1px solid #ccc" }}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                      value={selectedSpecialite}
                      onChange={handleSpecialiteChange}
                    >
                      <Select.Option value={"All"}>
                        Tous les types
                      </Select.Option>
                      {specialites.map((specialite) => (
                        <Select.Option
                          key={`${specialite.codespe} - ${specialite.intitule}`}
                          value={specialite.codespe}
                        >
                          {`${specialite.codespe} - ${specialite.intitule}`}
                        </Select.Option>
                      ))}
                    </Select>
                    
                  </Col>
                  <Col xs={12}>
                    <br></br>
                    <Input
                      placeholder="Recherche..."
                      bordered={false}
                      style={{ borderBottom: "1px solid #ccc" }}
                      onChange={(e) => handleSearch(e.target.value)}
                      onPressEnter={(e) => handleSearch(e.target.value)}
                    />
                  </Col>
                </Row>
              </Col>

              <Col xs={24} sm={12} lg={12}>
                <Row justify="end">
                  <Col span={24} style={{ textAlign: "right" }}>
                    <div style={{ display: "flex", gap: 8, marginBottom: "1rem" }}>
                      {[
                        { value: "a", label: "Tout" },
                        { value: "b", label: "Exclus" },
                        { value: "c", label: "Non exclus" },
                      ].map((item) => (
                        <button
                          key={item.value}
                          onClick={() => setSelectedOption(item.value)}
                          style={{
                            padding: "6px 14px",
                            borderRadius: 20,
                            border: "none",
                            cursor: "pointer",
                            fontSize: 13,
                            fontWeight: 500,
                            transition: "all 0.3s ease",
                            background: selectedOption === item.value
                              ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                              : "#f0f0f0",
                            color: selectedOption === item.value ? "#fff" : "#595959",
                            boxShadow: selectedOption === item.value
                              ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                              : "0 1px 3px rgba(0, 0, 0, 0.1)",
                          }}
                          onMouseEnter={(e) => {
                            if (selectedOption !== item.value) {
                              e.currentTarget.style.background = "#e0e0e0";
                              e.currentTarget.style.transform = "translateY(-1px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (selectedOption !== item.value) {
                              e.currentTarget.style.background = "#f0f0f0";
                              e.currentTarget.style.transform = "translateY(0)";
                            }
                          }}
                        >
                          {item.label}
                        </button>
                      ))}
                    </div>
                  </Col>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Space
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="buttonExport"
                        onClick={handleExport}
                        size="small"
                        icon={<ExportOutlined />}
                      >
                        Exporter
                      </Button>
                      <Popconfirm
                        title="Êtes-vous sûr de vouloir supprimer les actes sélectionnés ?"
                        onConfirm={Handlesuppresion}
                        okText="Oui"
                        cancelText="Non"
                      >
                        <Button
                          disabled={selectedRowKeys.length === 0}
                          icon={<DeleteOutlined />}
                          size="small"
                          style={{ backgroundColor: "red", color: "white" }}
                        >
                          Supprimer
                        </Button>
                      </Popconfirm>

                      <Button
                        disabled={selectedRowKeys.length === 0}
                        onClick={handleExclude}
                        icon={<BlockOutlined />}
                        size="small"
                        style={{ backgroundColor: "#9e7203", color: "white" }}
                      >
                        Exclure
                      </Button>
                      <Button
                        onClick={handleResetAll}
                        icon={<SyncOutlined />}
                        size="small"
                        // style={{ backgroundColor: "#52c41a", color: "white" }}
                        className="buttonRefresh"
                      >
                        Actualiser
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>

          <Table
            rowKey={(record, index) => index + 1} // Démarre la numérotation à 1
            rowSelection={rowSelection}
            scroll={{ x: true }}
            className="custom-header1-table"
            showSorterTooltip={false}
            bordered
            columns={columns}
            dataSource={filteredData}
           
            loading={loading}
          />
        </Col>

        <Col xs={24} xl={6}>
          <Form
            form={form}
            size="small"
            onFinish={handleFormSubmit}
            layout="vertical"
            autoComplete="off"
          >
            {/* {!showEditForm && ( */}
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title
                    level={4}
                    style={{
                      margin: 0,
                      marginLeft: "15px",
                      color: "#ffffff",
                    }}
                  >
                    {" "}
                    Nouvel Acte
                  </Title>
                </div>
              }
            >
              <Form.Item
                name="codespe"
                label="Spécialité / Structure"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de spécialité",
                  },
                ]}
              >
                <Select
                   showSearch
                   allowClear={true}
                   filterOption={(input, option) =>
                     option.children.toLowerCase().includes(input.toLowerCase())
                   }
                  value={selectedSpecialite}
                  placeholder="Sélectionnez un type de spécialité"
                  onChange={handleSpecialiteChange}
                >
                  {specialites.map((specialite) => (
                    <Option key={specialite.codespe} value={specialite.codespe}>
                   {`${specialite.codespe} - ${specialite.intitule}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="codeprest"
                label="Prestation"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de prestation",
                  },
                ]}
              >
                <Select
                  showSearch
                  allowClear={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Sélectionnez un type de prestation"
                  onChange={handlePrestationChange}
                >
                  {prestations.map((prestation) => (
                    <Option
                      key={prestation.codeprest}
                      value={prestation.codeprest}
                    >
                      {`${prestation.codeprest} - ${prestation.intitule}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="codeacte"
                label="Libellé de l'acte"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un libellé d'acte",
                  },
                ]}
              >
                <Select
                  showSearch
                      allowClear={true}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                       placeholder="Sélectionnez un libellé d'acte">
                  {prestationAffect.map((acte) => (
                    <Option key={acte.codeacte} value={acte.codeacte}>
                      {`${acte.libacte}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item>
                <Space>
                  <Button htmlType="submit">Enregister</Button>
                </Space>
              </Form.Item>
            </Card>
          
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default AffectationActe;
